// TouchPoint types (mirrors backend DTOs for Email, Phone, Social, SMS, Meeting campaigns)
export var TouchPointType;
(function (TouchPointType) {
    TouchPointType["Email"] = "Email";
    TouchPointType["Phone"] = "Phone";
    TouchPointType["Social"] = "Social";
    TouchPointType["Meeting"] = "Meeting";
})(TouchPointType || (TouchPointType = {}));
export const TOUCHPOINT_TYPE_LABELS = {
    Email: 'Email',
    Phone: 'Call',
    Social: 'Social Post',
    Meeting: 'Meeting',
};
export const TOUCHPOINT_TYPE_ICONS = {
    Email: '📧',
    Phone: '📞',
    Social: '📱',
    Meeting: '🤝',
};
